import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Unauthorized.css';

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <div className="unauthorized-page">
            <div className="unauthorized-card">
                <div className="unauthorized-icon">🚫</div>
                <h1>Access Denied</h1>
                <p className="unauthorized-message">
                    You don't have permission to access this dashboard.
                    Only users with the Admin role on the RVN City Discord server can access this system.
                </p>
                <div className="unauthorized-info">
                    <h3>What you can do:</h3>
                    <ul>
                        <li>Contact a server administrator to request access</li>
                        <li>Make sure you're logged in with the correct Discord account</li>
                        <li>Verify that you have the Admin role on the server</li>
                    </ul>
                </div>
                <div className="unauthorized-actions">
                    <button 
                        className="btn-primary"
                        onClick={() => navigate('/login')}
                    >
                        Try Again
                    </button>
                    <a 
                        href="https://discord.gg/AbrJNT3C" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="btn-secondary"
                    >
                        Join Discord Server
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
